import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { Tabs } from 'antd';

import { PitstopButton, PitstopModal } from 'shared';

import { InfoCircleOutlined } from '@ant-design/icons';
import DealershipChooser from 'components/DealershipChooser';
import RoutineServiceForm from 'containers/Form/RoutineServiceForm';
import AppStore from 'stores/App';
import NewIssueReport from './NewIssueReport';
import RoutineServiceGuide from './routine-service-guide.mp4';
import ServiceHistory from './ServiceHistory';

const GuideContainer = styled.div`
  display: flex;

  i,
  p {
    margin: auto 5px;
  }
`;

const ModalContainer = styled(PitstopModal)`
  &&& {
    .ant-modal-footer {
      display: none;
    }
  }
`;

const MaintenancePage = (props) => {
  const { history, match } = props;

  const VIDEO_MODAL_ID = 'VIDEO_MODAL_ID';

  const [activeKey, setActiveKey] = useState(
    match.params.selector || 'routine-service'
  );

  const items = [
    {
      key: 'routine-service',
      label: 'Routine Service',
      children: <RoutineServiceForm />,
    },
    {
      key: 'new-issue-report',
      label: 'New Issue Report',
      children: <NewIssueReport />,
    },
    {
      key: 'log-maintenance-report',
      label: 'Upload Service History/Repair Order Data',
      children: <ServiceHistory />,
    },
  ];

  const changeTab = (newActiveKey) => {
    history.replace(`/maintenance/${newActiveKey}`);
    setActiveKey(newActiveKey);
  };

  return (
    <>
      <h1>PM Scheduler</h1>
      <p>Edit vehicles maintenance with your preferences</p>
      <PitstopButton
        type="primary"
        onClick={() => AppStore.openModals.set(VIDEO_MODAL_ID, true)}
      >
        <GuideContainer>
          <InfoCircleOutlined />
          <p>Explore Maintenance Module</p>
        </GuideContainer>
      </PitstopButton>

      <ModalContainer
        id={VIDEO_MODAL_ID}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
        width="60%"
        height="50%"
        style={{ marginTop: 30 }}
        bodyStyle={{ padding: 0 }}
        onOk={() => {}}
        onCancel={() => AppStore.openModals.set(VIDEO_MODAL_ID, false)}
      >
        <video width="100%" height="100%" controls muted>
          <source src={RoutineServiceGuide} type="video/mp4" />
        </video>
      </ModalContainer>

      <DealershipChooser />
      <Tabs
        defaultActiveKey={activeKey}
        size="large"
        onChange={changeTab}
        items={items}
      />
    </>
  );
};

MaintenancePage.propTypes = {
  carId: PropTypes.number,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withRouter(observer(MaintenancePage));
